import { QuickFiltersProps } from '@components/table/QuickFilters';
import { QuoteDataGridType, UnderwriterHomePageTabs } from '@pages/Quotes/QuotesTable/DataGrid.constants';

export const UWHomePageAllTransactionTab = {
  All: 'all',
  MyTransactions: 'myTransactions',
  MyActionItems: 'myActionItems',
  Closed: 'closed',
  ShowImportantFirst: 'showImportantFirst',
};

export type TActionItemCountPerType = Pick<
  Record<QuoteDataGridType, number>,
  | QuoteDataGridType.UWHomePageAllTransaction
  | QuoteDataGridType.UWHomePageNewBusiness
  | QuoteDataGridType.UWHomePageRenewals
  | QuoteDataGridType.UWHomePageEndorsements
>;

export const getQuickFilterGroups = (
  viewType: QuoteDataGridType,
  other: {
    defaultFilter?: string;
    actionItemCountPerViewType?: TActionItemCountPerType;
  },
): QuickFiltersProps['quickFilterGroup'] => {
  if (viewType === QuoteDataGridType.UWHomePageRecentlyViewed) {
    // none
    return [];
  }

  if (UnderwriterHomePageTabs.includes(viewType)) {
    return [
      {
        queryKey: 'uwTab',
        quickFilters: [
          {
            label: 'All',
            value: UWHomePageAllTransactionTab.All,
            defaultChecked: other.defaultFilter === 'All',
          },
          {
            label: 'My Transactions',
            value: UWHomePageAllTransactionTab.MyTransactions,
            defaultChecked: other.defaultFilter === 'My Transactions',
          },
          {
            label: 'My Action Items',
            count:
              viewType === QuoteDataGridType.UWHomePageAllTransaction ||
              viewType === QuoteDataGridType.UWHomePageNewBusiness ||
              viewType === QuoteDataGridType.UWHomePageRenewals ||
              viewType === QuoteDataGridType.UWHomePageEndorsements
                ? other.actionItemCountPerViewType?.[viewType]
                : undefined,
            value: UWHomePageAllTransactionTab.MyActionItems,
            defaultChecked: other.defaultFilter === 'My Action Items',
          },
          {
            label: 'Closed',
            value: UWHomePageAllTransactionTab.Closed,
            defaultChecked: other.defaultFilter === 'Closed',
          },
        ],
      } as QuickFiltersProps['quickFilterGroup'][0],
      // REMOVED FOR NOW, may come back some day </3
      // {
      //   queryKey: 'toggle',
      //   quickFilters: [
      //     {
      //       label: 'Show Important First',
      //       value: UWHomePageAllTransactionTab.ShowImportantFirst,
      //     },
      //   ],
      // },
    ];
  }

  return [
    {
      queryKey: 'statuses',
      quickFilters: [
        {
          label: 'All Active',
          defaultChecked: true,
          value: 'all',
        },
        {
          label: 'Incomplete',
          value: 'incomplete',
        },
        {
          label: 'Ready to Bind',
          value: 'readyToBind',
        },
        {
          label: 'Referred To Underwriting',
          value: 'referredToUnderwriting',
        },
        {
          label: 'Closed',
          value: 'closed',
        },
        {
          label: 'Favorites',
          value: 'favorites',
        },
      ],
    } as QuickFiltersProps['quickFilterGroup'][0],
    {
      queryKey: 'quickFilter',
      quickFilters: [
        {
          label: 'My Watchlist',
          value: 'watchlist',
        },
        {
          label: 'All Quotes',
          value: 'all',
          defaultChecked: true,
        },
      ],
    },
  ];
};
